module.exports = __webpack_public_path__ + "media/images/computer-cd9fc6563cdf93eb0d6233de5b0ef462.png";